import React from "react";
import "./index.css";
import { Alert, Button, Col, Row, Space } from "antd";
import { generateNonce, getWeEAMUrl } from "../main/OauthUtils";


type LogOutLayoutState = {
  isReady: boolean;
  oAuthUrl: string;
  error: string;
  authenticated: boolean;
};
class LogOutLayout extends React.Component<LogOutLayoutState> {
  state: LogOutLayoutState = {
    isReady: false,
    oAuthUrl: undefined,
    error: undefined,
    authenticated: false
  };

  componentDidMount() {
    Promise.resolve(getWeEAMUrl()).then((url) => {
        this.setState({
          isReady: true,
          oAuthUrl: url
        });
      }
    )
      .catch((err) => {
        this.setState({
          isReady: true,
          error: err
        });
      });
  }
  
  isTrustedRedirectUrl(parsedUrl: URL): boolean {
    const trustedHosts = ["bmwgroup.net", "bmwgroup.com", "bmw.com", "bmw.net"];
    return parsedUrl.protocol === "https:" &&
      trustedHosts.some(root => parsedUrl.hostname === root || parsedUrl.hostname.endsWith(`.${root}`));
  }

  oauthLogin() {
    const url = `${this.state.oAuthUrl}&nonce=${generateNonce("xxx")}`;

    try {
      const parsedUrl = new globalThis.URL(url);
      if (!this.isTrustedRedirectUrl(parsedUrl)) {
        console.error("BLOCKED REDIRECT — Untrusted URL:", parsedUrl.hostname);
        return;
      }
      // Navigate using the re-serialized, validated URL rather than the raw
      // input string, so the URL that is actually parsed and validated is the
      // one that is used for the redirect.
      window.location.assign(parsedUrl.href);
    }
    catch (e) {
      console.error("Invalid redirect URL:", e);
    }
  }
  render() {
    return (
      <div className="content">
        <Row gutter={16}>
          <Col className="gutter-row" style={{ marginLeft: "5px" }}>
            <div
              style={{ textAlign: "center", width: "1000px", height: "300px", marginLeft: "5px" }}>
              <div className="title-header-card-text">
                eDocument Portal
              </div>
              <div className="title-header-card-text">
                {sessionStorage.getItem("sessionExpired") === "true"
                ?
                  <Alert showIcon={true} message={"Session expired"}
                    description="Your session expired, click the button to login again"
                    type="success"
                  />
                :
                  <Alert showIcon={true} message={"Successfully Logout"}
                    description="You have successfully logout, click the button to login again"
                    type="success"
                  />
                }


              </div>
              <Row gutter={8}>
                <Col xs={24} sm={6} md={4}>
                  <Button type="primary" size="large" className="w-100 mt10" onClick={() => this.oauthLogin()}>
                    LOGIN
                  </Button>
                </Col>
              </Row>

            </div>
          </Col>
        </Row>
      </div>

    );
  }
}

export default LogOutLayout;
